import React from 'react';
import { useFeatureFlag } from '../../hooks/useFeatureFlag'; 

const TestFeatureFlagComponent = () => {
  const isFeatureActive = useFeatureFlag('newFeature');

  return (
    <div className="text-sm text-gray-700 dark:text-gray-300">
      {isFeatureActive ? <p>New Feature is Active</p> : <p>New Feature is Not Active</p>}
    </div>
  );
};

export default TestFeatureFlagComponent;